export const CONFIG = {
  GOOGLE_CLIENT_ID: '935689564912-lehm6slkkl34fcuiiiiin4pba6jlalsd.apps.googleusercontent.com',
  DEBUG: true // 调试模式 - 启用以追踪Google登录问题
};

// Google按钮配置
export const GOOGLE_BUTTON_CONFIG = {
  CUSTOM: {
    type: "standard",
    theme: "outline",
    size: "large",
    text: "continue_with",
    shape: "rectangular",
    logo_alignment: "left",
    width: 240
  },
  FALLBACK: {
    type: "standard",
    theme: "outline",
    size: "large",
    text: "signin_with",
    shape: "rectangular", 
    logo_alignment: "left",
    width: 240
  }
};